require('./bootstrap');

// Moment locale config
require('./moment.config');

// Config
Vue.config.errorHandler = function (err, vm) {
  // handle error
  console.log(err);
}

Vue.config.ignoredElements = ['html:button'];

// Vue Meta
import Meta from 'vue-meta';
Vue.use(Meta, {
  keyName: 'metaData', // the component option name that vue-meta looks for meta info on.
})

// Vuex Store
import store from './store';


// Vuex
import { mapGetters, mapActions } from 'vuex';


// Directives
import '@/directives/lazy';


// Custom plugin to handle toast notifications
import Toasts from './plugins/toasts';
Vue.use(Toasts, { store });


// Custom plugin to handle modals
import Modals from './plugins/modals';
Vue.use(Modals, { store });

// Custom plugin to handle the overlay
import Overlay from './plugins/overlay';
Vue.use(Overlay, { store });


// Custom plugin to handle localization translations
import Speak from './plugins/speak';
Vue.use(Speak);


// Custom plugin to easily handle media queries 
import MQ from './plugins/mq';
Vue.use(MQ, {
  queries: {
    'xs-max': '(max-width: 767px)',
    'sm-min': '(min-width: 768px)',
    'sm-max': '(max-width: 991px)',
    'md-min': '(min-width: 992px)',
    'md-max': '(max-width: 1279px)',
    'lg-min': '(min-width: 1280px)',
    'lg-max': '(max-width: 1439px)',
    'xlg-min': '(min-width: 1440px)'
  }
});


// Router
import router from './router';
import { sync } from 'vuex-router-sync';
sync(store, router);

// Root component
import Root from '@/components/Root.vue';

// Set app version
Laravel.appVersion = '1.4.2';

// Create our Vue instance
const app = new Vue({
  name: 'App',
  
  store,
  router,

  computed: {
    ...mapGetters([
      'drawer',
      'global',
      'modals',
      'user'
    ])
  },

  methods: {
    ...mapActions([
      'setUser',
      'setUserInitialised',
      'getFavouriteCasinosSummary',
      'getFavouriteGamesSummary',
      'getFavouriteOffersSummary',
      'getFavouriteSuppliersSummary',
      'checkForPendingFavourites',
      'closeDrawer',
      'closeSideNav'
    ])
  },

  mounted () {   
    if (Laravel.user === null) {
      Laravel.jwtToken = '';
      portal.loginActionPerformed = false;
    }

    if (Laravel.user) {
      // Set vuex user state
      this.setUser(Laravel.user);

      // Get users favourites
      let favouriteCasinos = this.getFavouriteCasinosSummary();
      let favouriteGames = this.getFavouriteGamesSummary();
      let favouriteOffers = this.getFavouriteOffersSummary();
      let favouriteSuppliers = this.getFavouriteSuppliersSummary();
      
      // Using Promise.All removes a race issue where
      // user favourites may not have returned yet,
      // but pendingFavourites has
      Promise
        .all([favouriteCasinos, favouriteGames, favouriteOffers, favouriteSuppliers])
        .then(this.checkForPendingFavourites);

      if (!this.user.isInitialised) {
        this.setUserInitialised().then(() => {
          // Notify user they are logged in
          this.$toast.add({ type: 'success', text: 'You\'re Logged In' });
        })
      }
    }

    const appVersion = localStorage.getItem('version');

    // Check users app version
    if (appVersion) {
      if (appVersion === Laravel.appVersion) return;

      this.$toast.add({ 
        type: 'warning', 
        duration: 30000, 
        text: 'Casino.eu has been upgraded. Click here to refresh.', 
        action: () => {
          localStorage.removeItem('version');
          window.location.reload(true);
        }
      });
    } else {
      localStorage.setItem('version', Laravel.appVersion);
    }
  },

  render: h => h(Root)
});

router.beforeResolve((to, from, next) => {
  // Act as "301" redirect for hashed routes
  if (to.hash.includes('/play')) {
    let newUrl = to.hash.slice(1);
    return next(newUrl)
  }

  next();
});

// Runs whenever the route changes
router.beforeEach((to, from, next) => {
  // If modals open, ensure they close when changing routes
  if (app.modals.length) app.$modal.removeAll();

  // If drawer is open, ensure it closes when changing routes
  if (app.drawer.isDrawerActive) app.closeDrawer();

  // If side nav is open, ensure it closes when changing routes
  if (app.global.isSideNavActive) app.closeSideNav();

  next();
});

portal.onAuthentication(e => {
  if (e.user) {
    Laravel.user = e.user;
  }

  app.$mount('#app');
});

export default app;


// WEBPACK FOOTER //
// ./resources/assets/js/app/app.js